import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LuciAccordionComponent} from './luci-accordion.component';
import {LuciAccordionPanelModule} from './luci-accordion-panel/luci-accordion-panel.module';



@NgModule({
  declarations: [LuciAccordionComponent],
  exports: [LuciAccordionComponent],
  imports: [
    CommonModule,
    LuciAccordionPanelModule
  ]
})
export class LuciAccordionModule { }
